// extracted by mini-css-extract-plugin
module.exports = {"container":"CartPart_container__1CdID","heading":"CartPart_heading__2Kg-0","bannerImg":"CartPart_bannerImg__1CYAD"};